import { useQuery } from "@tanstack/react-query";
import { fetchGoodsCategories } from "@/lib/services/appointmentModalService";

/**
 * Hook to fetch all goods categories for the modal.
 * @param enabled - Whether to enable the query (default: true)
 */
export function useGoodsCategories(enabled: boolean = true) {
    return useQuery({
        queryKey: ["goodsCategories"],
        queryFn: fetchGoodsCategories,
        enabled,
        staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    });
}
